@if (snackbarService.state().isVisible) {
<div [class]="snackbarClasses()" [@slideAnimation]="animationDirection()" (click)="dismiss()" role="alert"
    aria-live="polite">
    @if (hasIcon(snackbarService.state().type)) {
    <ng-icon class="snackbar__icon" [name]="getIconName(snackbarService.state().type)" size="22"
        strokeWidth="2"></ng-icon>
    }
    <span class="snackbar__message">{{ snackbarService.state().message }}</span>
</div>
}